export default __webpack_public_path__ + "static/APP_1_1-f39050e71e70a1d5893607f103f940a0.png";